import { NA_CONTACT_EMAIL } from '../../utility/constants';

export const footerLinks = [
  {
    name: 'Free Trial',
    link: '/trial',
    isExternal: false,
  },
  {
    name: 'For Business',
    link: '/course/business',
    isExternal: false,
  },
  {
    name: 'Refer a Friend',
    link: '/refer-a-friend',
    isExternal: false,
  },
  {
    name: 'Questions?',
    link: '/faq',
    isExternal: false,
  },
  {
    name: 'About Us',
    link: '/about-us',
    isExternal: false,
  },
  {
    name: 'Blog',
    link: 'https://blog.nas.academy',
    isExternal: true,
  },
  {
    name: 'T&C',
    link: '/enrolment-terms',
    isExternal: false,
  },
  {
    name: 'Privacy',
    link: '/privacy',
    isExternal: false,
  },
  {
    name: 'Contact Us',
    link: `mailto:${NA_CONTACT_EMAIL}`,
    isExternal: true,
  },
];
